export interface IScopesExpiry {
  scope: string
  expiry: string
}

export interface IMemberModel {
  userId: string
  firstName: string
  lastName: string
  email: string
  displayName: string
  products: string[]
  scopes: string[]
  scopesExpiry: IScopesExpiry[]
  roles: string[]
  permissions: string[]
  datafilters: string[]
}

export type FrontendState = {
  scopes: { [key: string]: boolean }
  scopesExpiry: { [key: string]: boolean }
  scopeExpiryDate: string
  roles: { [key: string]: boolean }
}

export class MemberModel implements IMemberModel {
  userId: string
  firstName: string
  lastName: string
  email: string
  displayName: string
  products: string[]
  scopes: string[]
  scopesExpiry: IScopesExpiry[]
  roles: string[]
  permissions: string[]
  datafilters: string[]
  frontendState: FrontendState

  constructor(data: Partial<MemberModel>) {
    // Assign properties from the data object
    this.userId = data.userId || ''
    this.firstName = data.firstName || ''
    this.lastName = data.lastName || ''
    this.email = data.email || ''
    this.displayName = data.displayName || ''
    this.products = data.products || []
    this.scopes = data.scopes || []
    this.scopesExpiry = data.scopesExpiry || []
    this.roles = data.roles || []
    this.permissions = data.permissions || []
    this.datafilters = data.datafilters || []

    // Process frontendStates
    this.frontendState = {
      scopes: {},
      scopesExpiry: {},
      scopeExpiryDate: '',
      roles: {},
    }

    if (this.scopes) {
      for (let scope of this.scopes) {
        this.frontendState.scopes[scope] = true
      }
      for (let scopeExpiry of this.scopesExpiry) {
        this.frontendState.scopesExpiry[`"${scopeExpiry.scope}"`] = true
      }

      if (this.scopesExpiry.length > 0) {
        const earliestExpiry = this.scopesExpiry.reduce((earliest, current) => {
          return new Date(current.expiry) < new Date(earliest.expiry)
            ? current
            : earliest
        }, this.scopesExpiry[0])
        this.frontendState.scopeExpiryDate = earliestExpiry.expiry
      }
    }

    if (this.roles) {
      for (let role of this.roles) {
        this.frontendState.roles[role] = true
      }
    }
  }

  private IsExpiryConfigured(scope: string): boolean {
    return this.scopesExpiry.some((se) => se.scope === scope)
  }
}
